/* WRLD TAGS · wt-city-pass.js (v5, Sept 19 2026: two-step card turn instead of the 3D flip, needs wt-city-pass.css v2;
   v4: on a collection page the result button scrolls up to the caps instead of
   reloading the same page; v3: the two buttons can be switched any number of times, no lock (Jaime);
   v2: email step falls back to a real form submit when Shopify answers
   with its bot challenge, and the stamp is restored after the page comes back with customer_posted=true)
   Runs the boarding pass card printed by sections/wt-city-pass.liquid. Everything it needs (city, figure, questions,
   labels, product variant, discount code) is in the JSON the section prints in <script type="application/json">.
   Flow: odometer rolls to the real visitor figure when the card scrolls into view -> "I was one of them" /
   "I live here" (remembered per city on this phone) -> "Prove it" flips the card -> 5 questions -> optional email
   step (Shopify customer form, tagged wt-quiz + quiz-<city> + tier-<tier>; Omnisend syncs the tags) -> stamp ->
   add the cap to the cart through the theme's own cart events (drawer opens) / share image (1080x1080 PNG). */
(function () {
  'use strict';
  var CHECK = '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(t, m) { return String(t || '').replace(/\[(\w+)\]/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function setup(root) {
    if (root.__wtcp) return;
    root.__wtcp = true;
    var cfgEl = root.querySelector('script[type="application/json"]');
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var Q = (C.questions || []).filter(function (q) { return q.q && q.a && q.a.length > 1; });
    var $ = function (s) { return root.querySelector(s); };
    var countEl = $('.wt-cp__count'), label = $('.wt-cp__label'), qbody = $('.wt-cp__qbody'), qn = $('.wt-cp__qn'), rider = $('.wt-cp__rider');
    var toast = $('.wt-cp__toast');
    var key = 'wt-cp-' + (C.code || 'x').toLowerCase();
    var mine = store(key + '-vote') || null, qi = 0, score = 0, tier = null, emailed = false;

    /* ---------- odometer ---------- */
    function build(n) {
      countEl.innerHTML = '';
      fmt(n).split('').forEach(function (ch) {
        if (ch === ',') { var s = document.createElement('span'); s.className = 'wt-cp__sep'; s.textContent = ','; countEl.appendChild(s); return; }
        var d = document.createElement('span'); d.className = 'wt-cp__d';
        var strip = document.createElement('span'); for (var i = 0; i < 10; i++) { var k = document.createElement('i'); k.textContent = i; strip.appendChild(k); }
        strip.style.transform = 'translateY(-' + ch + 'em)'; d.appendChild(strip); countEl.appendChild(d);
      });
    }
    function roll(n) {
      var digits = fmt(n).replace(/,/g, '').split(''), cols = countEl.querySelectorAll('.wt-cp__d');
      if (cols.length !== digits.length) { build(n); return; }
      cols.forEach(function (col, i) { col.firstChild.style.transform = 'translateY(-' + digits[i] + 'em)'; });
    }
    var started = false;
    function startCount() {
      if (started || !C.visitors) return; started = true;
      var from = Math.round(C.visitors * 0.71 / 1000000) * 1000000;
      if (from < 1000000 || String(from).length !== String(C.visitors).length) from = Math.max(0, C.visitors - Math.pow(10, String(C.visitors).length - 2) * 3);
      build(from);
      setTimeout(function () { roll(C.visitors); }, 150);
    }
    if (C.visitors) build(C.visitors);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { startCount(); o.disconnect(); } }, { threshold: .35 }).observe(root);
    } else startCount();

    /* ---------- vote ---------- */
    var M = { city: C.city, code: C.code, year: C.year, visitors: fmt(C.visitors || 0) };
    function labelText() {
      if (mine === 'from') return fill(C.t.afterFrom, M);
      if (mine === 'been') return fill(C.t.afterBeen, M);
      return fill(C.t.label, M);
    }
    function paintVote() {
      root.querySelectorAll('[data-vote]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-vote') === mine); });
      if (mine) root.classList.add('wt-cp--voted');
      label.textContent = labelText();
    }
    root.querySelectorAll('[data-vote]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-vote');
        if (mine === v) return;
        mine = v; store(key + '-vote', v);
        paintVote();
      });
    });
    if (mine) paintVote();

    /* ---------- quiz ---------- */
    function riderTo(step) { if (rider) rider.style.left = 'calc(34px + (100% - 92px) * ' + (step / Q.length) + ')'; }
    function renderQ() {
      var item = Q[qi];
      qn.textContent = fill(C.t.quizHead, M) + ' · ' + (qi + 1) + '/' + Q.length;
      var html = '<div class="wt-cp__step"><p class="wt-cp__q">' + esc(item.q) + '</p><div class="wt-cp__opts">';
      item.a.forEach(function (t, i) { html += '<button class="wt-cp__opt" type="button" data-i="' + i + '">' + esc(t) + CHECK + '</button>'; });
      qbody.innerHTML = html + '</div></div>';
      qbody.querySelectorAll('.wt-cp__opt').forEach(function (o) { o.addEventListener('click', answer); });
    }
    function answer(e) {
      var pick = +e.currentTarget.getAttribute('data-i'), item = Q[qi], opts = qbody.querySelectorAll('.wt-cp__opt');
      opts.forEach(function (o) { o.disabled = true; o.classList.add('is-dim'); });
      var c = Math.min(item.c, opts.length - 1);
      opts[c].classList.remove('is-dim'); opts[c].classList.add('is-right');
      if (pick === c) score++; else { opts[pick].classList.remove('is-dim'); opts[pick].classList.add('is-wrong'); }
      riderTo(qi + 1);
      setTimeout(function () { qi++; if (qi < Q.length) renderQ(); else finish(); }, 900);
    }
    function tierFor(s) {
      var pct = s / Q.length;
      if (pct >= 0.8) return C.tiers[2];
      if (pct >= 0.4) return C.tiers[1];
      return C.tiers[0];
    }
    function finish() {
      tier = tierFor(score);
      if (C.email && C.email.on && !emailed) renderGate(); else renderResult();
    }

    /* ---------- email step (Shopify customer form; Omnisend syncs the customer and the tags) ---------- */
    function renderGate() {
      qn.textContent = fill(C.t.quizHead, M) + ' · ' + fill(C.t.done, M);
      qbody.innerHTML = '<div class="wt-cp__step wt-cp__gate"><h3>' + esc(fill(C.email.heading, M)) + '</h3><p>' + esc(fill(C.email.sub, M)) + '</p>' +
        '<form class="wt-cp__field" novalidate><input type="email" name="email" autocomplete="email" inputmode="email" placeholder="' + esc(C.email.placeholder) + '" required>' +
        '<button class="wt-cp__btn wt-cp__btn--solid" type="submit">' + esc(C.email.button) + '</button></form>' +
        '<p class="wt-cp__err" hidden></p>' +
        '<button class="wt-cp__skip" type="button">' + esc(C.email.skip) + '</button></div>';
      var form = qbody.querySelector('form'), err = qbody.querySelector('.wt-cp__err'), btn = form.querySelector('button');
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var email = (form.email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = C.email.invalid; err.hidden = false; return; }
        err.hidden = true; btn.disabled = true; btn.textContent = C.email.sending;
        var body = new URLSearchParams();
        body.set('form_type', 'customer'); body.set('utf8', '✓');
        body.set('contact[email]', email);
        body.set('contact[tags]', 'wt-quiz,quiz-' + (C.code || '').toLowerCase() + ',tier-' + (tier.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-'));
        var root_url = (window.theme && theme.routes && theme.routes.root_url ? theme.routes.root_url.replace(/\/$/, '') : '');
        /* fallback: a real form post. Shopify may show its bot challenge, then comes back to this page with
           customer_posted=true and the stamp is restored from sessionStorage (see restore() below) */
        var hardSubmit = function () {
          try { sessionStorage.setItem('wt-cp-pending', JSON.stringify({ key: key, tier: tier, score: score })); } catch (e) {}
          var f = document.createElement('form'); f.method = 'POST'; f.action = root_url + '/contact'; f.style.display = 'none';
          var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
          body.forEach(function (v, n) { add(n, v); });
          add('return_to', location.pathname + '?customer_posted=true#wt-cp-' + (C.code || '').toLowerCase());
          document.body.appendChild(f); f.submit();
        };
        fetch(root_url + '/contact', { method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow' })
          .then(function (r) {
            var u = r.url || '';
            if (u.indexOf('customer_posted=true') !== -1 || (r.ok && u.indexOf('challenge') === -1 && u.indexOf('/contact') === -1)) {
              emailed = true; store(key + '-email', '1'); say(C.email.toast); renderResult(); return;
            }
            hardSubmit();
          })
          .catch(function () { hardSubmit(); });
      });
      qbody.querySelector('.wt-cp__skip').addEventListener('click', renderResult);
    }

    /* ---------- result ---------- */
    function renderResult() {
      qn.textContent = fill(C.t.result, M);
      var TM = { city: C.city, code: C.code, tier: tier.name, score: score, total: Q.length, price: C.product ? C.product.price : '' };
      var html = '<div class="wt-cp__step wt-cp__result"><p class="wt-cp__score">' + esc(fill(C.t.score, TM)) + '</p>' +
        '<div class="wt-cp__stamp">' + esc(tier.name) + '<small>' + esc(C.code) + ' · WRLD TAGS</small></div>' +
        '<p class="wt-cp__rtxt">' + esc(fill(C.t.youAre, TM)) + '<br>' + esc(fill(tier.line, TM)) + '</p>';
      if (emailed && C.email.code) html += '<p class="wt-cp__codebox">' + esc(fill(C.email.codeLabel, TM)) + '<b>' + esc(C.email.code) + '</b></p>';
      html += '<div class="wt-cp__ract">';
      if (C.product && C.product.variant) html += '<button class="wt-cp__btn wt-cp__btn--solid" type="button" data-add>' + esc(fill(C.t.add, TM)) + '</button>';
      else if (C.product && C.product.url) html += '<a class="wt-cp__btn wt-cp__btn--solid" href="' + esc(C.product.url) + '">' + esc(fill(C.t.shop, TM)) + '</a>';
      if (C.share) html += '<button class="wt-cp__btn" type="button" data-share>' + esc(C.t.share) + '</button>';
      html += '</div><button class="wt-cp__skip wt-cp__again" type="button">' + esc(C.t.again) + '</button></div>';
      qbody.innerHTML = html;
      var add = qbody.querySelector('[data-add]'); if (add) add.addEventListener('click', function () { addToCart(add); });
      var sh = qbody.querySelector('[data-share]'); if (sh) sh.addEventListener('click', share);
      var shop = qbody.querySelector('a.wt-cp__btn');
      if (shop && shop.getAttribute('href') === location.pathname) {
        shop.addEventListener('click', function (ev) { ev.preventDefault(); try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } });
      }
      qbody.querySelector('.wt-cp__again').addEventListener('click', function () { qi = 0; score = 0; riderTo(0); renderQ(); });
    }

    function addToCart(btn) {
      var id = C.product.variant; if (!id || btn.disabled) return;
      var was = btn.textContent; btn.disabled = true; btn.textContent = C.t.adding;
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var cfg = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      cfg.body = JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections });
      fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', cfg)
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status || state.errors) { btn.disabled = false; btn.textContent = was; say(C.t.addFail); return; }
          return fetch((window.theme && theme.routes && theme.routes.cart_url) || '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = state.sections;
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            var drawer = document.getElementById('CartDrawer');
            if (drawer && typeof drawer.show === 'function') drawer.show(btn); else if (!window.theme) location.href = '/cart';
            btn.disabled = false; btn.textContent = C.t.added;
            setTimeout(function () { btn.textContent = was; }, 2500);
          });
        })
        .catch(function () { btn.disabled = false; btn.textContent = was; say(C.t.addFail); });
    }

    /* ---------- share image ---------- */
    function rr(x, X, Y, W, H, R) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); }
    function share() {
      var c = document.createElement('canvas'); c.width = 1080; c.height = 1080; var x = c.getContext('2d');
      var head = '800 200px ' + (getComputedStyle(root.querySelector('.wt-cp__code')).fontFamily || 'Helvetica, Arial');
      x.fillStyle = '#f7f7f7'; x.fillRect(0, 0, 1080, 1080);
      x.fillStyle = '#fff'; x.strokeStyle = '#c9c6bf'; x.lineWidth = 3; rr(x, 120, 180, 840, 720, 36); x.fill(); x.stroke();
      x.fillStyle = '#171717'; x.font = head; x.textAlign = 'left'; x.fillText(C.code, 170, 420);
      x.font = '600 30px Menlo, monospace'; x.fillText((C.subline || C.city).toUpperCase(), 172, 470);
      x.setLineDash([14, 12]); x.beginPath(); x.moveTo(170, 530); x.lineTo(910, 530); x.stroke(); x.setLineDash([]);
      var t = (tier.name || '').toUpperCase();
      x.save(); x.translate(540, 720); x.rotate(-0.14); x.lineWidth = 10; x.strokeStyle = '#171717';
      x.font = head.replace('200px', '120px'); x.textAlign = 'center'; var w = x.measureText(t).width + 120;
      rr(x, -w / 2, -95, w, 190, 28); x.stroke(); x.fillStyle = '#171717'; x.fillText(t, 0, 45); x.restore();
      x.font = '600 28px Menlo, monospace'; x.textAlign = 'center'; x.fillStyle = '#171717';
      x.fillText('WRLDTAGS.COM  ·  ' + score + '/' + Q.length + ' ON THE ' + C.code + ' LOCAL QUIZ', 540, 990);
      var name = 'wrldtags-' + (C.code || 'city').toLowerCase() + '-stamp.png';
      c.toBlob(function (blob) {
        var file = null; try { file = new File([blob], name, { type: 'image/png' }); } catch (e) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
          navigator.share({ files: [file], title: 'WRLD TAGS ' + C.code }).catch(function () {});
          return;
        }
        var a = document.createElement('a'); a.download = name; a.href = URL.createObjectURL(blob); document.body.appendChild(a); a.click(); a.remove();
        say(C.t.saved);
      }, 'image/png');
    }

    function say(t) { if (!toast || !t) return; toast.textContent = t; toast.classList.add('is-on'); setTimeout(function () { toast.classList.remove('is-on'); }, 2400); }

    /* ---------- card turn: squeeze to the edge, swap faces, open again (no 3D) ---------- */
    function turn(toBack) {
      root.classList.add('wt-cp--turning');
      setTimeout(function () {
        root.classList.toggle('wt-cp--showback', !!toBack);
        root.classList.toggle('wt-cp--back', !!toBack);
        /* force a layout so the browser animates the reopening instead of jumping */
        void root.offsetWidth;
        root.classList.remove('wt-cp--turning');
      }, 340);
    }

    /* ---------- restore after a real form post (bot challenge path) ---------- */
    function restore() {
      var raw = null; try { raw = sessionStorage.getItem('wt-cp-pending'); } catch (e) {}
      if (!raw) return false;
      var pend = null; try { pend = JSON.parse(raw); } catch (e) {}
      if (!pend || pend.key !== key) return false;
      try { sessionStorage.removeItem('wt-cp-pending'); } catch (e) {}
      if (location.search.indexOf('customer_posted=true') === -1) return false;
      tier = pend.tier; score = pend.score || 0; emailed = true; store(key + '-email', '1');
      if (!mine) { mine = 'been'; paintVote(); }
      riderTo(Q.length); renderResult();
      root.classList.add('wt-cp--back', 'wt-cp--showback');
      setTimeout(function () { try { root.scrollIntoView({ block: 'center' }); } catch (e) {} }, 50);
      /* eslint-disable-line */
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      return true;
    }
    restore();

    /* ---------- start ---------- */
    var start = $('[data-start]');
    if (start) {
      if (!Q.length) start.closest('.wt-cp__invite').style.display = 'none';
      start.addEventListener('click', function () {
        qi = 0; score = 0; riderTo(0); renderQ();
        turn(true);
      });
    }

    /* ---------- live local time ---------- */
    var timeEl = $('[data-time]');
    function tick() {
      if (!timeEl) return;
      try { timeEl.textContent = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: C.tz || 'America/New_York' }).format(new Date()); }
      catch (e) { timeEl.textContent = new Date().toTimeString().slice(0, 5); }
    }
    tick(); setInterval(tick, 15000);
  }

  function init() { document.querySelectorAll('.wt-cp[data-wt-city-pass]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();